let Profils = [
  {
    "name": "operator",
    "glyph": "fa fa-send",
    "caption": "Multimodal",
    "link": "dashboard/operator",
    "details": [
      {
        "link": "dashboard/operator",
        "glyph": "fa fa-dashboard",
        "caption": "Tableau de bord"
      },
      {
        "link": "schedules",
        "glyph": "fa fa-calendar-o",
        "caption": "Schedules"
      },
      {
        "link": "bls",
        "glyph": "fa fa-copy",
        "caption": "Houses",
        "links": [
          {
            "link": "bls",
            "glyph": "fa fa-send",
            "caption": "Tous"
          },
          {
            "link": "bls/air",
            "glyph": "fa fa-plane",
            "caption": "Air"
          },
          {
            "link": "bls/sea",
            "glyph": "fa fa-ship",
            "caption": "Sea"
          }
        ]
      },
      {
        "link": "filetransports",
        "glyph": "fa fa-file-o",
        "caption": "Masters",
        "links": [
          {
            "link": "filetransports",
            "glyph": "fa fa-send",
            "caption": "Tous"
          },
          {
            "link": "filetransports/air",
            "glyph": "fa fa-plane",
            "caption": "Air"
          },
          {
            "link": "filetransports/sea",
            "glyph": "fa fa-ship",
            "caption": "Sea"
          }
        ]
      },
      {
        "link": "containers",
        "glyph": "fa fa-cube",
        "caption": "Conteneurs"
      },
      {
        "link": "loadingplan",
        "glyph": "fa fa-truck",
        "caption": "Plan de chargement"
      },
      {
        "link": "buying",
        "glyph": "fa fa-money",
        "caption": "Achat",
        "links": [
          {
            "link": "buyingtraction",
            "glyph": "fa fa-truck",
            "caption": "Comparatif Traction"
          },
          {
            "link": "buyingseafret",
            "glyph": "fa fa-ship",
            "caption": "Comparatif Frêt maritime"
          },
          {
            "link": "buyingseafretindex",
            "glyph": "fa fa-line-chart",
            "caption": "Indice Frêt maritime"
          }
        ]
      }
    ]
  },
  {
    "name": "air",
    "glyph": "fa fa-plane",
    "caption": "Air",
    "link": "dashboard/operator",
    "details": [
      {
        "link": "dashboard/operator",
        "glyph": "fa fa-dashboard",
        "caption": "Tableau de bord"
      },
      {
        "link": "bls/air",
        "glyph": "fa fa-copy",
        "caption": "Houses"
      },
      {
        "link": "filetransports/air",
        "glyph": "fa fa-file-o",
        "caption": "Masters"
      }
    ]
  },
  {
    "name": "sea",
    "glyph": "fa fa-ship",
    "caption": "Sea",
    "link": "dashboard/operator",
    "details": [
      {
        "link": "dashboard/operator",
        "glyph": "fa fa-dashboard",
        "caption": "Tableau de bord"
      },
      {
        "link": "schedules",
        "glyph": "fa fa-calendar-o",
        "caption": "Schedules"
      },
      {
        "link": "bls/sea",
        "glyph": "fa fa-copy",
        "caption": "Houses"
      },
      {
        "link": "filetransports/sea",
        "glyph": "fa fa-file-o",
        "caption": "Masters"
      },
      {
        "link": "containers",
        "glyph": "fa fa-cube",
        "caption": "Conteneurs"
      },
      {
        "link": "loadingplan",
        "glyph": "fa fa-truck",
        "caption": "Plan de chargement"
      }
    ]
  },
  {
    "name": "customs",
    "glyph": "fa fa-clipboard",
    "caption": "Douane",
    "link": "dashboard/customs",
    "details": [
      {
        "link": "customs",
        "glyph": "fa fa-file-o",
        "caption": "Déclarations"
      }
    ]
  },
  {
    "name": "logistician",
    "glyph": "fa fa-building",
    "caption": "Logistique",
    "link": "logistics",
    "details": [
      {
        "link": "logistics",
        "glyph": "fa fa-dashboard",
        "caption": "Tableau de bord"
      },
      {
        "link": "logistics/stock",
        "glyph": "fa fa-cubes",
        "caption": "Etat de quai"
      },
      {
        "link": "logistics/entries",
        "glyph": "fa fa-plus",
        "caption": "Entrées"
      },
      {
        "link": "logistics/exits",
        "glyph": "fa fa-minus",
        "caption": "Sorties"
      },
      {
        "link": "logistics/references",
        "glyph": "fa fa-cube",
        "caption": "Références"
      }
    ]
  },
  {
    "name": "accountant",
    "glyph": "fa fa-calculator",
    "caption": "Comptabilité",
    "link": "dashboard/accountant",
    "details": [
      {
        "link": "dashboard/accountant",
        "glyph": "fa fa-dashboard",
        "caption": "Tableau de bord"
      },
      {
        "link": "currency",
        "glyph": "fa fa-usd",
        "caption": "Devises",
        "links": [
          {
            "link": "currencies",
            "glyph": "fa fa-usd",
            "caption": "Devises"
          },
          {
            "link": "currencyrates",
            "glyph": "fa fa-bar-chart",
            "caption": "Taux"
          }
        ]
      },
      {
        "link": "bls/unlock",
        "glyph": "fa fa-unlock-alt",
        "caption": "Déblocage"
      },
      {
        "link": "invoices",
        "glyph": "fa fa-money",
        "caption": "Factures"
      },
      {
        "link": "debts",
        "glyph": "fa fa-money",
        "caption": "Créances"
      }
    ]
  },
  {
    "name": "commercial",
    "glyph": "fa fa-comments",
    "caption": "Commercial",
    "link": "dashboard/commercial",
    "details": [
      {
        "link": "dashboard/commercial",
        "glyph": "fa fa-dashboard",
        "caption": "Tableau de bord"
      },
      {
        "link": "customers",
        "glyph": "fa fa-group",
        "caption": "Clients"
      },
      {
        "link": "stat",
        "glyph": "fa fa-line-chart",
        "caption": "Statistique",
        "links": [
          {
            "link": "commercialperformance",
            "glyph": "fa fa-trophy",
            "caption": "Performance"
          },
          {
            "link": "rentcustomer",
            "glyph": "fa fa-trophy",
            "caption": "Répartition"
          }
        ]
      }
    ]
  },
  {
    "name": "quality",
    "glyph": "fa fa-certificate",
    "caption": "Qualité",
    "link": "dashboard/quality",
    "details": [
      {
        "link": "incidents",
        "glyph": "fa fa-warning",
        "caption": "Incidents"
      },
      {
        "link": "facturation",
        "glyph": "fa fa-money",
        "caption": "Facturation",
        "links": [
          {
            "link": "invoices",
            "glyph": "fa fa-plus",
            "caption": "Vente"
          }
        ]
      },
      {
        "link": "file",
        "glyph": "fa fa-send",
        "caption": "Exploitation",
        "links": [
          {
            "link": "filetransports",
            "glyph": "fa fa-file-o",
            "caption": "Masters"
          },
          {
            "link": "bls",
            "glyph": "fa fa-copy",
            "caption": "Houses"
          },
          {
            "link": "containers",
            "glyph": "fa fa-cube",
            "caption": "Conteneurs"
          }
        ]
      }
    ]
  },
  {
    "name": "director",
    "glyph": "fa fa-user-secret",
    "caption": "Directeur",
    "link": "dashboard/director",
    "details": [
      {
        "link": "dashboard/director",
        "glyph": "fa fa-dashboard",
        "caption": "Tableau de bord"
      },
      {
        "link": "stat",
        "glyph": "fa fa-line-chart",
        "caption": "Statistique",
        "links": [
          {
            "link": "profitlist",
            "glyph": "fa fa-heartbeat",
            "caption": "Santé"
          },
          {
            "link": "commercialperformance",
            "glyph": "fa fa-trophy",
            "caption": "Performance"
          },
          {
            "link": "rentcustomer",
            "glyph": "fa fa-trophy",
            "caption": "Répartition"
          }
        ]
      }
    ]
  },
  {
    "name": "administrator",
    "glyph": "fa fa-cogs",
    "caption": "Administrateur",
    "link": "administration",
    "details": [
      {
        "link": "tools",
        "glyph": "fa fa-cogs",
        "caption": "Tools",
        "links": [
          {
            "link": "administration/databases",
            "glyph": "fa fa-database",
            "caption": "Databases"
          },
          {
            "link": "dbforms",
            "glyph": "fa fa-wpforms",
            "caption": "Forms"
          },
          {
            "link": "translation",
            "glyph": "fa fa-language",
            "caption": "Translation"
          },
          {
            "link": "right",
            "glyph": "fa fa-lock",
            "caption": "Droits"
          }
        ]
      },
      {
        "link": "datas",
        "glyph": "fa fa-database",
        "caption": "Général",
        "links": [
          {
            "link": "continents",
            "glyph": "fa fa-globe",
            "caption": "Continents"
          },
          {
            "link": "countries",
            "glyph": "fa fa-flag",
            "caption": "Pays"
          },
          {
            "link": "cities",
            "glyph": "fa fa-map-signs",
            "caption": "Cities"
          },
          {
            "link": "languages",
            "glyph": "fa fa-language",
            "caption": "Languages"
          },
          {
            "link": "currencies",
            "glyph": "fa fa-usd",
            "caption": "Currencies"
          }
        ]
      },
      {
        "link": "datas",
        "glyph": "fa fa-space-shuttle",
        "caption": "Transport",
        "links": [
          {
            "link": "addresstypes",
            "glyph": "fa fa-wrench",
            "caption": "Address Types"
          },
          {
            "link": "airports",
            "glyph": "fa fa-road",
            "caption": "Aéroport"
          },
          {
            "link": "seaports",
            "glyph": "fa fa-anchor",
            "caption": "Port"
          },
          {
            "link": "vessels",
            "glyph": "fa fa-ship",
            "caption": "Navires"
          },
          {
            "link": "dggroups",
            "glyph": "fa fa-fire-extinguisher",
            "caption": "DG Group"
          },
          {
            "link": "dgclasses",
            "glyph": "fa fa-fire-extinguisher",
            "caption": "DG Class"
          },
          {
            "link": "dguns",
            "glyph": "fa fa-fire-extinguisher",
            "caption": "DG UN"
          },
          {
            "link": "hscodes",
            "glyph": "fa fa-tags",
            "caption": "Code"
          },
          {
            "link": "hscodechapters",
            "glyph": "fa fa-tags",
            "caption": "Chapters"
          },
          {
            "link": "hscodesections",
            "glyph": "fa fa-tags",
            "caption": "Sections"
          },
          {
            "link": "filetransporttypes",
            "glyph": "fa fa-wrench",
            "caption": "Job Types"
          },
          {
            "link": "transports",
            "glyph": "fa fa-wrench",
            "caption": "Transports"
          },
          {
            "link": "transportlines",
            "glyph": "fa fa-wrench",
            "caption": "Transport lines"
          },
          {
            "link": "incoterms",
            "glyph": "fa fa-gavel",
            "caption": "Incoterms"
          }
        ]
      },
      {
        "link": "reports",
        "glyph": "fa fa-paint-brush",
        "caption": "Documentation",
        "links": [
          {
            "link": "reporttypes",
            "glyph": "fa fa-object-ungroup",
            "caption": "Document Types"
          },
          {
            "link": "reports",
            "glyph": "fa fa-file-text",
            "caption": "Documents"
          }
        ]
      },
      {
        "link": "communications",
        "glyph": "fa fa-share-alt",
        "caption": "Communication",
        "links": [
          {
            "link": "emails",
            "glyph": "fa fa-envelope",
            "caption": "Emails"
          }
        ]
      },
      {
        "link": "process",
        "glyph": "fa fa-code-fork",
        "caption": "Processus",
        "links": [
          {
            "link": "dbformhavesteps",
            "glyph": "fa fa-code-fork",
            "caption": "Etapes"
          }
        ]
      },
      {
        "link": "users",
        "glyph": "fa fa-user-circle",
        "caption": "Users"
      },
      {
        "link": "EDI",
        "glyph": "fa fa-cloud-download",
        "caption": "EDI File",
        "links": [
          {
            "link": "edifiles",
            "glyph": "fa fa-file",
            "caption": "EDI Files"
          },
          {
            "link": "edihouses",
            "glyph": "fa fa-copy",
            "caption": "EDI Houses"
          },
          {
            "link": "edigoods",
            "glyph": "fa fa-cubes",
            "caption": "EDI Goods"
          }
        ]
      }
    ]
  }
]
export { Profils }